import React from "react";
export const Providers = React.lazy(() => import('./Providers/Providers'));